import React from 'react';
import { IconLogo, IconLock } from '../../utils/icons';
import Grid from '../Grid';
export interface HeaderProps {
	baseUrl: string
	title: string
}

const Header = (props: HeaderProps) => {
	const { baseUrl, title } = props;

	return (
		<header className="lhp-header" id="lhp-header">
			<Grid className="container">
				<a href="/" className="header-logo" aria-label="Tilbage til pka.dk forside">
					<IconLogo />
				</a>
				<a href={ baseUrl } className="header-title" aria-label="Tilbage til start">{ title }</a>
				<a href="/logout" className="header-logout" aria-label="Log af">
					<IconLock />
					<span>Log af</span>
				</a>
			</Grid>
		</header>
	);
};

export default Header;